import { Provider } from "components/education/EducationContext";
import { EducationList } from "components/education/EducationList";
import React from "react";

export const Educations = () => {
    return (
        <Provider>
            <EducationList />
        </Provider>
    );
};
